import * as actionTypes from "./actionTypes";
import initialState from "reducers/initialState";

const globalParamsReducer = (state = initialState.params, action) => {
  switch (action.type) {
    case actionTypes.LOAD_GLOBAL_PARAMS_STARTED: {
      return {
        ...state,
        loading: true
      };
    }

    case actionTypes.LOAD_GLOBAL_PARAMS_SUCCESS:
      return {
        items: {...action.payload},
        loading: false,
        loaded: true
      };

    case actionTypes.SAVE_GLOBAL_PARAMS_SUCCESS: {
      const { name, value } = action.payload;
      let result = { ...state };
      result[name] = value;
      return result;
    }

    default:
      return state;
  }
};

export default globalParamsReducer;
